import { DeleteOutlined } from "@ant-design/icons";
import { Flex, Form } from "antd";
import { useState } from "react";
import { ContractType } from "tm-shared/types";

import BaseButton from "@/components/BaseButton";
import { useAppSelector } from "@/hooks/redux";
import { ContractFormValues } from "@/types/form";

import { AddProductsModal } from "../AddProductsModal";
import { ContractProductRow } from "./ContractProductRow";
import { StyledErrorsWrapper } from "./Styled";

export const AssortmentMatrix = () => {
    const { products } = useAppSelector((s) => s.offline);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const form = Form.useFormInstance<ContractFormValues>();

    const selectedBarcodes = Form.useWatch("barcodes", form) || [];

    const menuItems = [
        {
            key: "1",
            label: (
                <Flex gap="5px" align="center">
                    <DeleteOutlined /> Видалити
                </Flex>
            ),
        },
    ];

    return (
        <Flex vertical gap={20} style={{ marginBottom: 24 }}>
            <BaseButton type="primary" onClick={() => setIsModalOpen(true)}>
                Обрати товари
            </BaseButton>

            <Flex vertical gap={12}>
                <Form.List name="barcodes">
                    {(fields, { remove, add }, { errors }) => {
                        return (
                            <>
                                {fields.map((field) => {
                                    const barcode = form.getFieldValue([
                                        "barcodes",
                                        field.name,
                                    ]);

                                    return (
                                        <ContractProductRow
                                            key={field.key}
                                            barcode={barcode}
                                            productName={
                                                products?.[barcode]?.name ||
                                                "Невідомий товар"
                                            }
                                            field={field}
                                            menuItems={menuItems}
                                            remove={remove}
                                        />
                                    );
                                })}

                                <StyledErrorsWrapper>
                                    <Form.ErrorList errors={errors} />
                                </StyledErrorsWrapper>

                                <AddProductsModal
                                    contractType={ContractType.AssortmentMatrix}
                                    open={isModalOpen}
                                    onClose={() => setIsModalOpen(false)}
                                    selectedProducts={selectedBarcodes}
                                    onAdd={add}
                                    onRemove={(barcode) => {
                                        const index =
                                            selectedBarcodes.findIndex(
                                                (p: string) => p === barcode,
                                            );
                                        if (index !== -1) remove(index);
                                    }}
                                />
                            </>
                        );
                    }}
                </Form.List>
            </Flex>
        </Flex>
    );
};
